/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_ResubscribeInputs */

const fr_rapid_eager_otter_resubscribe = /** @type {(inputs: Rapid_Eager_Otter_ResubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réactiver`)
};

/**

* @param {Rapid_Eager_Otter_ResubscribeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_resubscribe = /** @type {((inputs?: Rapid_Eager_Otter_ResubscribeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_ResubscribeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_resubscribe(inputs)
});